import { Pipe, PipeTransform, inject } from '@angular/core';
import type { ResultStatusCode } from '../models/result-status.models';
import { TranslationService } from '../services/translation.service';

@Pipe({
  name: 'resultStatus',
  standalone: true,
  pure: false,
})
export class ResultStatusPipe implements PipeTransform {
  private readonly translationService = inject(TranslationService);

  transform(
    code: ResultStatusCode | null | undefined,
    label?: string | null,
    raw?: string | null,
  ): string {
    if (!code) return label ?? '';

    if (code === 'lap_down') {
      const match = `${label ?? ''} ${raw ?? ''}`.match(/\b(\d+)\b/);
      return this.translationService.translate('resultStatus.lapDown', match?.[1] ?? '?');
    }

    const keyByCode: Record<Exclude<ResultStatusCode, 'lap_down'>, string> = {
      dnf: 'resultStatus.dnf',
      dsq: 'resultStatus.dsq',
      dns: 'resultStatus.dns',
      nc: 'resultStatus.nc',
      outside_time_limit: 'resultStatus.outsideTimeLimit',
      not_timed: 'resultStatus.notTimed',
    };

    return this.translationService.translate(keyByCode[code]);
  }
}
